import { useState } from 'react'
import { useLocation } from 'react-router-dom'

import { CountdownTimer } from 'src/components'
import Login from 'src/ui/templates/Login'

import useEmailConfirmtionApi from './useEmailConfirmtionApi'

const EmailConfirmation = () => {
  const location = useLocation()
  const queryParams = new URLSearchParams(location.search)
  const email = queryParams.get('email')
  const { resendEmail } = useEmailConfirmtionApi()

  const [time, setTime] = useState<number>(30)
  const [isTimerDone, setTimerDone] = useState<boolean>(false)

  const handleResendEmail = async () => {
    if (email) {
      try {
        await resendEmail({ email })
        setTime(120)
        setTimerDone(false)
      } catch (err) {
        console.error('Resend email error', err)
      }
    }
  }

  return (
    <Login>
      <div className="grid gap-6 text-center">
        <h1 className="text-white ">Email confirmation</h1>
        <p className="text-lg text-white">
          You're almost ready to start enjoying ZoidCore. Just verify your email address.
        </p>
        {isTimerDone && (
          <span onClick={handleResendEmail} className="cursor-pointer text-main-blue">
            Resend email
          </span>
        )}
        {!isTimerDone && (
          <span className="text-white text-opacity-50">
            Resend email in{' '}
            <CountdownTimer time={time} setTimerDone={setTimerDone} setTime={setTime} />
          </span>
        )}
      </div>
    </Login>
  )
}

export default EmailConfirmation
